export default __webpack_public_path__ + "static/media/logo-footer.47bb5f6b.svg";